import React from 'react';
import SearchIcon         from '@mui/icons-material/Search';
import EditIcon           from '@mui/icons-material/Edit';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import MailOutlineIcon    from '@mui/icons-material/MailOutline';
import ShareIcon          from '@mui/icons-material/Share';
import CalendarTodayIcon  from '@mui/icons-material/CalendarToday';
import LayersIcon         from '@mui/icons-material/Layers';
import BarChartIcon       from '@mui/icons-material/BarChart';
import AttachMoneyIcon    from '@mui/icons-material/AttachMoney';
import CategoryIcon       from '@mui/icons-material/Category';
import GroupIcon          from '@mui/icons-material/Group';
import PublicIcon         from '@mui/icons-material/Public';

export const MODULES = {
  owner: [
    { id: 'keyword_analyzer',     name: 'Keyword Analyzer',   description: 'Discover high-impact keywords',                          icon: <SearchIcon fontSize="small" /> },
    { id: 'episode_optimizer_v2', name: 'Episode Optimizer',  description: 'Optimize episode titles and descriptions',               icon: <EditIcon fontSize="small" /> },
    { id: 'health_check_v2',      name: 'Health Check',       description: 'Audit RSS feed health',                                  icon: <HealthAndSafetyIcon fontSize="small" /> },
    { id: 'contact_owner',        name: 'Contact & Links',    description: 'Find podcast owner contact info',                        icon: <MailOutlineIcon fontSize="small" /> },
    { id: 'social_audit',         name: 'Social Audit',       description: 'Analyze social presence',                                icon: <ShareIcon fontSize="small" /> },
    { id: 'cadence_v2',           name: 'Cadence & Format',   description: 'Publishing schedule analysis',                           icon: <CalendarTodayIcon fontSize="small" /> },
    { id: 'theme_map_v2',         name: 'Theme Map',          description: 'Content theme extraction',                               icon: <LayersIcon fontSize="small" /> },
    { id: 'op3_downloads',        name: 'OP3 Downloads',      description: 'Download analytics',                                     icon: <BarChartIcon fontSize="small" /> },
    { id: 'sponsor_suggestions',  name: 'Sponsor Suggestions',description: 'Sponsorship opportunities',                              icon: <AttachMoneyIcon fontSize="small" /> },
  ],
  research: [
    { id: 'category_themes',  name: 'Category & Themes', description: 'Show category analysis',      icon: <CategoryIcon fontSize="small" /> },
    { id: 'guest_extractor',  name: 'Guest Extractor',   description: 'Extract guest information',    icon: <GroupIcon fontSize="small" /> },
    { id: 'social_scan_v2',   name: 'Social Scan',       description: 'Research social profiles',     icon: <PublicIcon fontSize="small" /> },
    { id: 'contact_research', name: 'Contact Info',      description: 'Research contact details',     icon: <MailOutlineIcon fontSize="small" /> },
    { id: 'op3_downloads',    name: 'OP3 Downloads',     description: 'Download analytics',           icon: <BarChartIcon fontSize="small" /> },
    { id: 'sponsor_finder',   name: 'Sponsor Finder',    description: 'Sponsorship intelligence',     icon: <AttachMoneyIcon fontSize="small" /> },
  ],
};

export const SIDEBAR_SECTIONS = {
  owner: {
    'SEO & Discovery':  ['keyword_analyzer', 'episode_optimizer_v2', 'health_check_v2', 'contact_owner', 'social_audit'],
    'Content Strategy': ['cadence_v2', 'theme_map_v2', 'op3_downloads', 'sponsor_suggestions'],
  },
  research: {
    'Show Intelligence':  ['category_themes', 'guest_extractor'],
    'Social & Contact':   ['social_scan_v2', 'contact_research'],
    'Downloads':          ['op3_downloads'],
    'Monetization Intel': ['sponsor_finder'],
  },
};
